import { useMutation, UseMutationOptions, useQueryClient } from '@tanstack/react-query';

import { TCommentType } from '@entities/comment/model/types';
import { commentsApi } from '@widgets/Comments/api';

type TDeleteCommentVariables = {
    positionGuid: string;
    commentType: TCommentType;
    commentId: string;
};

type TDeleteCommentMutationFn = (
    variables: TDeleteCommentVariables
) => ReturnType<typeof commentsApi.deleteCommentQueryOptions>;

type TUseSaveCommentOptions = Omit<
    UseMutationOptions<
        Awaited<ReturnType<TDeleteCommentMutationFn>>,
        unknown,
        TDeleteCommentVariables
    >,
    'mutationFn'
>;

export const useDeleteComment = ({ ...mutationOptions }: TUseSaveCommentOptions) =>
    {
        const queryClient = useQueryClient();

        return useMutation({
            ...mutationOptions,
            mutationFn: commentsApi.deleteCommentQueryOptions,
            onSuccess: async (data, variables, context) => {
                await queryClient.invalidateQueries({
                    queryKey: commentsApi.getCommentListQueryOptions({
                        positionGuid: variables.positionGuid,
                        commentType: variables.commentType,
                    }).queryKey,
                });

                await mutationOptions.onSuccess?.(data, variables, context);
            },
        });
    };
